import { OrderMissionEntity } from "@src/features/order/entities";

export const arcMissionOrderPath = (order: OrderMissionEntity) => {
  if (!order.waypoints || !Array.isArray(order.waypoints)) return [];

  return order.waypoints.filter(({ latitude, longitude }) => latitude && longitude)
    .map(({ latitude, longitude }) => ({ lat: latitude, lng: longitude }));
};